import * as utils from '@utils/form';
import { IMAGE_SIZE } from '@api/media/constants';

export const TABBED_ITEM_FIELDS = {
  TAB_TITLE: {
    name: 'title',
    label: 'Section title:',
    placeholder: 'Enter a title for the tab',
    rules: [{ required: true, message: 'Title is required' }],
  },
  TAB_DESCRIPTION: {
    name: 'description',
    label: 'Description:',
    rules: [{ required: true, message: 'Description is required' }],
  },
  TAB_VISIBILITY: {
    name: 'showSection',
  },
  TAB_IMAGE: {
    name: 'image',
    label: 'Image:',
    rules: [{ required: true, message: 'An image is required' }],
    size: IMAGE_SIZE['700x460'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
  },
};

export const SECTIONS = {
  name: 'sections',
  rules: [{ min: 1, max: 8 }],
};

export const FORM_PANEL = { SECTIONS };

export const TABBED_PANEL_INITS = {
  section: [],
};
